import useAxiosService from './useAxiosService'
import { IResponse } from 'interfaces/services'
import { EExamStatus } from 'pages/patientBooking/enums'
import { IUpdateExamQuery } from 'pages/patientReceive/interfaces'

const useProcessBookingService = () => {
  const { patch } = useAxiosService()

  const updateExamStatus = async (
    query: IUpdateExamQuery
  ): Promise<IResponse<any>> => {
    const response: any = await patch(
      '/clinic/booking/update-exam-status',
      query
    )
    return {
      ...response,
      data: response.data?.bookings
    } as IResponse<any>
  }

  const updateExamStatusInProgress = async (bookingId: number) => {
    const query: IUpdateExamQuery = {
      booking_id: bookingId,
      status: EExamStatus.InProgress
    }
    return updateExamStatus(query)
  }

  const updateExamStatusDataCollection = async (bookingId: number) => {
    const query: IUpdateExamQuery = {
      booking_id: bookingId,
      status: EExamStatus.DataCollection
    }
    return updateExamStatus(query)
  }

  const updateExamStatusWaiting = async (bookingId: number) => {
    const query: IUpdateExamQuery = {
      booking_id: bookingId,
      status: EExamStatus.Waiting
    }
    return updateExamStatus(query)
  }

  const updateExamStatusFinish = async (bookingId: number) => {
    const query: IUpdateExamQuery = {
      booking_id: bookingId,
      status: EExamStatus.Finished
    }
    return updateExamStatus(query)
  }

  return {
    updateExamStatusInProgress,
    updateExamStatusWaiting,
    updateExamStatusFinish,
    updateExamStatusDataCollection
  }
}

export default useProcessBookingService
